import React from 'react'
import { motion } from 'motion/react'

const paneSpring = {
  type: 'spring',
  stiffness: 850,
  damping: 40,
  restDelta: 0.5,
  restSpeed: 20,
}

/** Logbook ↔ schedule: linear exit fully offscreen, then spring enter. */
export const SlideLeftTransition = ({ children }) => (
  <motion.div
    style={{ width: '100%', willChange: 'transform' }}
    initial={{ x: '-120%' }}
    animate={{
      x: 0,
      transition: paneSpring,
    }}
    exit={{
      x: '-120%',
      transition: { type: 'tween', duration: 0.08, ease: 'linear' },
    }}
  >
    {children}
  </motion.div>
)

/** Stable shell for preference routes — panel slide is on PreferencesWrapper. */
export const PreferencesPageTransition = ({ children }) => (
  <motion.div initial={false}>{children}</motion.div>
)
